import * as React from 'react';
import {styled} from '@mui/material/styles';
import Button from '@mui/material/Button';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import {FormattedMessage} from "react-intl";

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

type UploadFileButtonProps = {
    color?: string;
    text?: string;
    onChange: (files: FileList | null) => void;
};

const UploadFileButton: React.FC<UploadFileButtonProps> = (props) => {
    return (
        <Button
            component="label"
            role={undefined}
            tabIndex={-1}
            variant="contained"
            size="small"
            startIcon={<CloudUploadIcon/>}>
            {props.text ? props.text : <FormattedMessage id={'COMMON_UPLOAD'}/>}
            <VisuallyHiddenInput type="file" onChange={(event) => props.onChange(event.target.files)}/>
            {/*<TextField type="file" hidden={true} onChange={(event) => {*/}
            {/*    console.log(event)*/}
            {/*}}/>*/}
        </Button>
    );
};

export default UploadFileButton;
